import React from 'react';
import s from './DetailsRightSide.scss';
const DetailsRightSide = ({ firstRow , secondRow  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['first-row']
    }, firstRow), /*#__PURE__*/ React.createElement("div", {
        className: s['second-row']
    }, secondRow));
};
DetailsRightSide.displayName = 'DetailsRightSide';
export default DetailsRightSide;
